import React from 'react'

import { useErrorBoundary } from 'react-error-boundary'

import { RenderFirstPageContract } from '@/components/shared/RenderFirstPageContract'
import { AppDependencyUnrecoverableError } from '@/errors/classes/AppDependencyUnrecoverableError'
import { CloudValuePropContract } from '@/pages/CloudValueProp'
import { PortalValuePropContract } from '@/pages/PortalValueProp'

export function LandingPageApp() {
  const { showBoundary } = useErrorBoundary()
  return (
    <RenderFirstPageContract
      contracts={[PortalValuePropContract, CloudValuePropContract]}
      whenNoneMatch={() => showBoundary(new AppDependencyUnrecoverableError())}
    />
  )
}
